import React from "react";
import "./HomeCollectionCss/HomeCollection.css";
import { useCart } from "../../Contexts/Cart.contexts";
import { FiSearch } from "react-icons/fi";

const HomeCollectionUpdate = ({
  onClose,
  testList,
  setTestList,
  setToggle,
}) => {
  const { cartItems, addToCart, removeFromCart } = useCart();

  // Toggle cart items
  const handleCheckboxChange = (test) => {
    const isChecked = cartItems.some((item) => item.id === test.service_id);
    if (isChecked) {
      removeFromCart(test.service_id);
    } else {
      addToCart({
        id: test.service_id,
        product: test.service_name,
        price: test.price,
        quantity: 1,
      });
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        className="modal-box"
        style={{
          maxWidth: "600px",
          width: "90%",
          background: "#fff",
          border: "1px solid #ddd",
          borderRadius: "12px",
          boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
          fontFamily: "Arial, sans-serif",
          overflow: "hidden",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            // padding: "6px 8px",
            borderBottom: "1px solid #ddd",
            fontSize: "20px",
            fontWeight: "600",
            color: "#0fb7a4",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Choose Test</span>
          <button
            style={{
              border: "none",
              // background: "transparent",
              fontSize: "22px",
              fontWeight: "bold",
              color: "#888",
              cursor: "pointer",
            }}
            onClick={onClose}
          >
            ✖
          </button>
        </div>

        {/* SEARCH BAR */}
        <div
          style={{
            padding: "10px 0px",
            borderBottom: "1px solid #eee",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #ccc",
              borderRadius: "6px",
              padding: "0 10px",
            }}
          >
            <FiSearch
              style={{
                color: "#0fb7a4",
                fontSize: "18px",
                marginRight: "8px",
              }}
            />

            <input
              type="text"
              placeholder="Search by Tests / Packages"
              onChange={(e) => {
                const searchTerm = e.target.value.toLowerCase();
                if (!searchTerm) {
                  setToggle((prev) => !prev);
                } else {
                  const filteredTests = testList.filter((test) =>
                    test.service_name.toLowerCase().includes(searchTerm)
                  );
                  setTestList(filteredTests);
                }
              }}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                padding: "8px 4px",
                fontSize: "0.9rem",
              }}
            />
          </div>
        </div>

        {/* TEST LIST TABLE */}
        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr
                style={{
                  background: "#0fb7a4",
                  color: "#fff",
                  textAlign: "left",
                  position: "sticky",
                  top: 0,
                  zIndex: 2,
                }}
              >
                <th style={{ padding: "10px 15px", width: "50px" }}></th>
                <th style={{ padding: "10px 15px" }}>Test Name</th>
                <th style={{ padding: "10px 15px", width: "100px" }}>Price</th>
              </tr>
            </thead>

            <tbody>
              {testList.map((test, i) => (
                <tr
                  key={i}
                  style={{
                    background: i % 2 === 0 ? "#f7f7f7" : "#e9e9e9",
                  }}
                >
                  <td style={{ padding: "10px 15px" }}>
                    <input
                      type="checkbox"
                      checked={cartItems.some(
                        (item) => item.id === test.service_id
                      )}
                      onChange={() => handleCheckboxChange(test)}
                    />
                  </td>
                  <td style={{ padding: "10px 15px" }}>{test.service_name}</td>
                  <td style={{ padding: "10px 15px" }}>₹{test.price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* SHOW SELECTED TESTS — ONLY IF CART HAS ITEMS */}
        {cartItems.length > 0 && (
          <>
            {/* SELECTED TESTS + TOTAL PRICE SECTION */}
            <div
              style={{
                padding: "6px 8px",
                borderTop: "1px solid #ddd",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "5px",
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "#0fb7a4",
                  }}
                >
                  Selected Test List ({cartItems.length})
                </div>

                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#0fb7a4",
                  }}
                >
                  Total Price (Rs.){" "}
                  {cartItems.reduce((sum, item) => sum + Number(item.price), 0)}
                </div>
              </div>

              <div
                style={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  borderRadius: "6px",
                  marginBottom: "10px",
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                {cartItems.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      background: "#e0e0e0",
                      padding: "6px 14px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {item.product}
                    <span
                      onClick={() => removeFromCart(item.id)}
                      style={{
                        marginLeft: "8px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      ✖
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* PROCEED BUTTON */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={() => onClose()}
                style={{
                  width: "30%",
                  background: "#0fb7a4",
                  color: "white",
                  padding: "8px",
                  fontSize: "0.8rem",
                  fontWeight: "500",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Proceed
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default HomeCollectionUpdate;
